import WebRedirect from './ui/webRedirect/webRedirect';

export default WebRedirect;
